import * as React from 'react';
import { useContext } from 'react';

import type { ProductType as BaseProductType } from '@coursera/event-pulse-types';

export type ProductType = Extract<BaseProductType, 'course' | 's12n'>;

export type EventingType = {
  product?: {
    id: string;
    type: Extract<ProductType, 'course' | 's12n'>;
  };
};

const EventingContext = React.createContext<EventingType>({});

export const useEventingProductData = () => {
  return useContext(EventingContext) ?? {};
};

export default EventingContext;
